"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _const = require("../const");

var _default = function _default(direction) {
  switch (direction) {
    case _const.DIRECTION_VERT:
      return ['top', 'bottom'];

    case _const.DIRECTION_HORZ:
      return ['left', 'right'];

    default:
      return [];
  }
};

exports["default"] = _default;